<template >
  <div>
    <div class="nav-top">
      <div class="tiops">
        <!-- <i class="el-icon-arrow-left" 
            style="color:#000000;font-size:18px;cursor:pointer;" 
            @click="withdraw"
            v-if="cRtData !==''">
              {{cRtData.readBook.bookName}}
            </i> -->
        {{ examName }}
      </div>
    </div>
    <div class="centreir paragraph" v-if="state === true">
      <div v-for="(items, index) in cRtData.contentList" :key="index">
        {{ items }}
      </div>
    </div>
    <div class="centreir" v-if="state === false">
      <el-row :gutter="10">
        <el-col :span="12">
          <div>
            答题进度 <span style="font-size: 3.4vh">{{ redIndex + 1 }}</span
            >/{{ cRtData.readQuestionsList.length }}
          </div>
        </el-col>
        <el-col :span="12">
          <div style="text-align: right; padding-right: 50px; color: #3685fa">
            剩余时间：{{ second }}S
          </div>
        </el-col>
      </el-row>
      <el-progress
        :text-inside="false"
        :percentage="percentage"
        :color="customColor"
        :format="format"
      ></el-progress>
      <!-- 选择题 -->
      <div class="questions" :class="{ disabled: isClick == true }">
        <div class="title">{{ redIndex + 1 }}.{{ radData.title }}</div>
        <div style="font-size: 24px" v-if="nextLevel == 1">
          答案：{{ radData.answer }}
        </div>
        <el-radio-group v-model="radio" @change="agreeChange">
          <el-form label-width="80px">
            <el-form-item
              label=""
              v-for="(is, inout) in radData.option"
              :key="`${redIndex}${inout}`"
            >
              <el-radio :label="is"></el-radio>
            </el-form-item>
          </el-form>
        </el-radio-group>
        <img
          class="centerImg"
          src="../../../assets/1-dui.png"
          v-if="xuanzhong == 1"
        />
        <img
          class="centerImg"
          src="../../../assets/1-cuo.png"
          v-if="xuanzhong == 2"
        />
        <!-- <div class="answer">
                    <span>答：</span>
					<input type="text" v-model="iptAnswer" class="uni-input" placeholder="请输入你的答案">
                </div>
                <div class="btn"><button @click="agreeChange">下一题</button></div> -->
      </div>
    </div>
    <div class="bommton">
      <div class="left">
        <div
          :class="indexs === nnns ? 'yuanActiv' : 'yuandian'"
          v-for="(item, nnns) in artData"
          :key="nnns"
        ></div>
      </div>
      <div class="dot" v-if="state === true && showBtn === true">
        <button class="tton ttonse" @click="ReadItWell">读好了</button>
      </div>
    </div>

    <el-dialog
      :title="cRtData.readBook.bookName"
      :visible.sync="centerDialogVisible"
      width="300px"
      :showClose="false"
      :close-on-click-modal="false"
      center
    >
      <p><span>作者：</span>{{ cRtData.readBook.author }}</p>
      <p>
        <span>类别：</span>{{ cRtData.readBook.readBookCategory.categoryName }}
      </p>
      <p><span>字数：</span>{{ cRtData.number }}字</p>
      <!-- <span class="sdfe">{{roueFet.prompt}}</span>
            <img class="dia-img" :src="roueFet.img" alt="" v-if="roueFet.stype===2"> -->
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <button class="confirmButton" @click="confirm(roueFet.stype)">
          {{ roueFet.butText }}
        </button>
      </span>
    </el-dialog>

    <!-- 章节弹窗 -->
    <el-dialog
      title=""
      :visible.sync="Visible"
      width="150px"
      custom-class="customClass"
      :showClose="false"
      :close-on-click-modal="false"
      center
    >
      <div class="roiut">
        <span style="color: #ffffff">{{ level }}</span>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { getCreate, posebmit } from "@/api/examination/exStart";
import { addEnterLog, addBehaviorLog } from "@/api/course/courseGames";
import screenfull from "screenfull";
import dayjs from "dayjs";
export default {
  data() {
    return {
      examName: "",
      iptAnswer: "", // 考试答题
      examId: this.$route.query.examId,
      title: "一千张糖纸",
      centerDialogVisible: false,
      roueFet: {
        prompt: "一千张糖纸",
        img: "",
        stype: 1, //控制开始图片显示不显示
        butText: "开始阅读",
      },
      Visible: false,
      level: "第一级",
      state: null,
      showBtn: false,
      percentage: 0,
      customColor: "#409eff",
      radio: "",
      second: 10,
      userInfo: "",
      articleIndex: 0, //获取到的数据下标处理
      artData: [],
      cRtData: {
        readBook: {
          readBookCategory: {},
        },
      },
      readList: [],
      radData: [],
      redIndex: 0,
      total: 0, //总答对提数
      timer: null,
      indexs: 0,
      reckonTime: 1,
      cunData: [], //每一级的数据统计
      transmit: {},
      startTime: 0,
      endTime: 0,
      nextLevel: 0,
      xuanzhong: 0,
      isClick: false,
      noBack: false,
      start: "",
      levelStartTime: null, //每一篇开始时间
    };
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener(
      "popstate",
      function (e) {
        history.pushState(null, null, document.URL);
      },
      false
    );
    this.nextLevel = sessionStorage.getItem("nextLevel");
    let infor = JSON.parse(sessionStorage.getItem("userInfo"));
    if (infor !== null) {
      this.userInfo = infor;
    }
    screenfull.toggle();
    this.screen();
  },
  mounted() {
    this.enter();
    window.onbeforeunload = (e) => {
      e = e || window.event;
      if (e) {
        e.returnValue = "关闭提示";
      }
      return "关闭提示";
    };
  },
  methods: {
    addEnterLog() {
      let obj = {
        type: 5, //考试
        memberId: this.userInfo.memberId,
        startTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        start: this.start,
      };
      addEnterLog(obj).then((res) => {});
    },
    // 记录行为日志
    addBehaviorLog(obj) {
      addBehaviorLog(obj).then((res) => {});
    },
    screen() {
      // 如果不允许进入全屏，发出不允许提示
      // if (screenfull.enabled) {
      //     this.$message("您的浏览器不能全屏");
      //     screenfull.toggle();
      //     return false;
      // }
      // this.$message.success("全屏啦");
    },
    enter() {
      let that = this;
      getCreate(that.examId).then((res) => {
        this.examName = res.data.examName;
        let objc = JSON.parse(res.data.examDetail);
        that.artData = objc;
        that.cRtData = that.artData[that.articleIndex];
        let bookn = that.articleIndex + 1;
        that.start =
          "第" + bookn + "篇：《" + that.cRtData.readBook.bookName + "》";
        that.addEnterLog();
        // 第一篇文章开始日志
        this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
        let obj = {
          memberId: this.userInfo.memberId,
          position: this.start,
          startTime: this.levelStartTime,
          type: 6,
        };
        this.addBehaviorLog(obj); //记录开始阅读日志
        that.centerDialogVisible = true;
      });
    },
    //小于10的拼接上0字符串
    addZero(s) {
      return s < 10 ? "0" + s : s;
    },
    confirm(eq) {
      this.centerDialogVisible = false;
      this.reckonTime = 1;
      this.state = true;
      setTimeout(() => {
        this.showBtn = true;
      }, 5000);
      this.timer = setInterval(() => {
        this.reckonTime++;
      }, 1000);
      if (this.indexs == 0) {
        let date = new Date();
        this.startTime = date.getTime();
      }
    },
    jumpCompleted() {
      this.$router.push({ path: "/completed" });
    },
    format(percentage) {
      return percentage === 100 ? "" : "";
    },
    //  读好了事件
    ReadItWell() {
      this.state = false;
      this.showBtn = false;
      this.redIndex = 0;
      clearInterval(this.timer);
      let list = this.cRtData.readQuestionsList;
      this.radData = list[this.redIndex];
      this.countdown();
    },
    countdown() {
      this.isClick = false;
      this.second = 10;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.second === 0) {
          this.agreeChange();
        } else {
          this.second--;
        }
      }, 1000);
    },
    agreeChange(val) {
      this.isClick = true;
      // 保存用户填写的答案
      this.artData[this.articleIndex].readQuestionsList[
        this.redIndex
      ].myAnswer = val;
      // let text = this.iptAnswer
      let text = val;
      clearInterval(this.timer);
      let list = this.cRtData.readQuestionsList;
      //  this.redIndex++  //下标++
      if (this.radData.answer === text) {
        this.xuanzhong = 1;
        this.total++; //总答对数
        this.percentage += 14.285;
        this.iptAnswer = "";
        if (this.redIndex === list.length - 1) {
          if (this.articleIndex === this.artData.length - 1) {
            this.noBack = true;
            this.percentage = 100;
            let date = new Date();
            this.endTime = date.getTime();
            this.isEnd = true;
            this.pusfunang();
            this.submit();
          } else {
            setTimeout(() => {
              this.pusfunang();
              this.articleIndex++;
              this.indexs++;
              this.xuanzhong = 0;
              this.cRtData = this.artData[this.articleIndex];
              // 下一篇文章开始日志
              let bookn = this.articleIndex + 1;
              this.start =
                "第" + bookn + "篇：《" + this.cRtData.readBook.bookName + "》";
              this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
              let obj = {
                memberId: this.userInfo.memberId,
                position: this.start,
                startTime: this.levelStartTime,
                type: 6,
              };
              this.addBehaviorLog(obj);
              this.state = true;
              this.reckonTime = 1;
              this.percentage = 0;
              this.centerDialogVisible = true;
              this.state = null;
            }, 1000);
          }
        } else {
          setTimeout(() => {
            this.xuanzhong = 0;
            this.redIndex++; //下标++
            this.radData = list[this.redIndex];
            this.radio = "";
            this.countdown();
          }, 1000);
        }
      } else {
        this.xuanzhong = 2;
        this.percentage += 14.285;
        this.iptAnswer = "";
        if (this.redIndex === list.length - 1) {
          if (this.articleIndex === this.artData.length - 1) {
            this.noBack = true;
            this.percentage = 100;
            let date = new Date();
            this.endTime = date.getTime();
            this.isEnd = true;
            this.pusfunang();
            this.submit();
          } else {
            setTimeout(() => {
              this.pusfunang();
              this.articleIndex++;
              this.indexs++;
              this.xuanzhong = 0;
              this.cRtData = this.artData[this.articleIndex];
              // 下一篇文章开始日志
              let bookn = this.articleIndex + 1;
              this.start =
                "第" + bookn + "篇：《" + this.cRtData.readBook.bookName + "》";
              this.levelStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
              let obj = {
                memberId: this.userInfo.memberId,
                position: this.start,
                startTime: this.levelStartTime,
                type: 6,
              };
              this.addBehaviorLog(obj);
              this.state = true;
              this.reckonTime = 1;
              this.percentage = 0;
              this.centerDialogVisible = true;
              this.state = null;
            }, 1000);
          }
        } else {
          setTimeout(() => {
            this.xuanzhong = 0;
            this.redIndex++; //下标++
            this.radData = list[this.redIndex];
            this.radio = "";
            this.countdown();
          }, 1000);
        }
      }
    },
    pusfunang() {
      let readSpeed = Math.ceil((this.cRtData.number * 60) / this.reckonTime);
      let readScore = Math.ceil((100 / 7) * this.total);
      let readEfficiency = Math.ceil((readScore * readSpeed) / 100);
      this.total = 0;
      let obj = {
        title: this.cRtData.readBook.bookName,
        readEfficiency: readEfficiency,
        readSpeed: readSpeed,
        readScore: readScore,
      };
      this.cunData.push(obj);
      // 记录当前文章结束日志
      let obj1 = {
        memberId: this.userInfo.memberId,
        startTime: this.levelStartTime,
        endTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        type: 6,
      };
      this.addBehaviorLog(obj1);
      let a = 0,
        b = 0,
        c = 0;
      let arr = this.cunData;
      arr.forEach((v) => {
        a += v.readEfficiency;
        b += v.readScore;
        c += v.readSpeed;
      });
      this.transmit = {
        memberId: this.userInfo.memberId,
        examId: this.examId, //  活动/考试id
        readEfficiency: Math.ceil(a / 5), //  阅读效率
        readSpeed: Math.ceil(c / 5), // 阅读速度
        readScore: parseFloat((b / 5).toFixed(2)), //  答题分数
        resultDetail: JSON.stringify(this.cunData), //  考试详情
        examType: 1, //  活动类型 1 考试 2活动 3比赛
      };
    },
    submit() {
      posebmit(this.transmit).then((res) => {
        this.transmit.TotalDuration = Math.floor(
          (this.endTime - this.startTime) / 1000
        );
        localStorage.setItem("conset", JSON.stringify(this.transmit));
        localStorage.setItem("artData", JSON.stringify(this.artData));
        setTimeout(() => {
          this.$router.push({
            path: "/exaComponen",
            query: {
              type: 1, //考试
            },
          });
        }, 1000);
      });
    },
    /* 
          退出
          */
    withdraw() {
      if (!this.noBack) {
        this.$confirm("退出后将失去本次考试机会，本次成绩作废", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let transmit = {
              memberId: this.userInfo.memberId,
              examId: this.examId, //  活动/考试id
              readEfficiency: 0, //  阅读效率
              readSpeed: 0, // 阅读速度
              readScore: 0, //  答题成绩
              resultDetail: "", //  考试详情
              examType: 1, //  活动类型 1 考试 2活动 3比赛
            };
            posebmit(transmit).then((res) => {
              this.$router.replace({
                path: "/examination",
              });
            });
          })
          .catch(() => {});
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
  },
};
</script>


<style lang="scss" scoped>
html {
  background: #f9f8fd;
}
.nav-top {
  min-width: 100%;
  height: 60px;
  color: #000000;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
  line-height: 60px;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .tiops {
    font-size: 24px;
    font-weight: bold;
  }
  // background-color: #FFFFFF;
}
.centreir {
  width: 100%;
  position: absolute;
  top: 60px;
  bottom: 60px;
  left: 0px;
  background: #eae8df;
  padding: 20px 40px;
  box-sizing: border-box;
  font-size: 3vh;
  text-indent: 2em;
  line-height: 2;
  text-align: justify;
  letter-spacing: 1.5px;
  overflow: auto; // 超出这个最大高度的数据，会被隐藏起来，上下滑动
  overflow-x: hidden; //隐藏x轴滚动条
}
.paragraph {
  font-size: 30px;
}
.centreir::-webkit-scrollbar {
  display: none;
}
.bommton {
  min-width: 100%;
  height: 60px;
  color: #000000;
  line-height: 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  .left {
    position: absolute;
    left: 10px;
    .yuandian {
      height: 20px;
      width: 20px;
      display: inline-block;
      background-color: #2097e7;
      border-radius: 50%;
      margin-left: 6px;
      margin-top: 5px;
    }
    .yuanActiv {
      height: 20px;
      width: 20px;
      display: inline-block;
      background-color: #45a91b;
      border-radius: 50%;
      margin-left: 6px;
      margin-top: 5px;
    }
  }
  .dot {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    .tton {
      color: #a6a7ab;
      width: 100px;
      height: 35px;
      border: none;
      border-radius: 30px;
      margin-left: 10px;
    }
    .ttonse {
      color: #ffffff;
      background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
    }
  }
}
.sdfe {
  text-align: center !important;
}
.dia-img {
  margin: 10px auto 0;
  width: 100px;
  height: 100px;
  display: block;
}
.confirmButton {
  width: 193px;
  height: 50px;
  border: none;
  border-radius: 30px;
  color: #ffffff;
  font-size: 18px;
  background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
}
::v-deep .el-dialog {
  display: flex;
  display: -ms-flex; /* 兼容IE */
  flex-direction: column;
  -ms-flex-direction: column; /* 兼容IE */
  margin: 0 !important;
  border-radius: 20px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  max-height: 100%;
  flex: 1;
  -ms-flex: 1 1 auto; /* 兼容IE */
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  font-size: 18px;
}

::v-deep .el-dialog__wrapper {
  /*隐藏ie和edge中遮罩的滚动条*/
  overflow: hidden;
}

::v-deep .customClass {
  background: #2d92ff;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  .el-dialog__header {
    padding: 0 !important;
  }
}
::v-deep .el-progress-bar {
  width: 99%;
}
::v-deep .el-form-item {
  margin-bottom: 10px;
}
.questions {
  width: 670px;
  background: #ffffff;
  margin: 5vh auto 0;
  text-indent: 0;
  line-height: 1.5;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  .title {
    margin-bottom: 20px;
  }
  ::v-deep .el-radio__label {
    font-size: 2.6vh;
    color: #000000;
  }
  .centerImg {
    width: 150px;
    height: 150px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
  .answer {
    display: flex;
    align-items: center;

    input {
      font-size: 24px !important;
      border: none;
      outline: none;
      border-bottom: 2px solid #000;
    }
  }
  .btn {
    width: 30%;
    margin: 0 auto;

    button {
      color: #fff;
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 30px;
      font-size: 22px;
      margin-top: 100px;
      background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
    }
  }
}
.disabled {
  pointer-events: none;
}
</style>